export const normalizeText = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const formatProdi = (prodi) => {
  if (!prodi) return '-';
  return `${prodi.jenjang} - ${prodi.nama_prodi}`;
};

const LOOKUP_CACHE_TTL_MS = 30000;
let lookupCache = {
  timestamp: 0,
  data: null,
};

export const clearProfileLookupsCache = () => {
  lookupCache = {
    timestamp: 0,
    data: null,
  };
};

export const fetchProfileLookups = async (supabase, { force = false } = {}) => {
  const now = Date.now();
  if (!force && lookupCache.data && now - lookupCache.timestamp < LOOKUP_CACHE_TTL_MS) {
    return lookupCache.data;
  }

  const prodiResult = await supabase
    .schema('akreditasi')
    .from('prodi')
    .select('id, kode_prodi, nama_prodi, jenjang')
    .order('nama_prodi', { ascending: true });

  if (prodiResult.error) {
    throw new Error(`Gagal mengambil prodi: ${prodiResult.error.message}`);
  }

  const data = {
    prodiList: prodiResult.data || [],
  };

  lookupCache = {
    timestamp: now,
    data,
  };

  return data;
};

export const findProfileProdi = (profile, prodiList) => {
  const profileValue = normalizeText(profile?.prodi);
  if (!profileValue) return null;

  const byCode = prodiList.find(
    (item) => normalizeText(item.kode_prodi) === profileValue
  );
  if (byCode) return byCode;

  const exactMatch = prodiList.find((item) =>
    [
      item.nama_prodi,
      `${item.jenjang} ${item.nama_prodi}`,
      `${item.jenjang} - ${item.nama_prodi}`,
    ]
      .map(normalizeText)
      .includes(profileValue)
  );
  if (exactMatch) return exactMatch;

  const nameMatches = prodiList.filter(
    (item) => normalizeText(item.nama_prodi) === profileValue
  );

  return nameMatches.length === 1 ? nameMatches[0] : null;
};

export const hydrateProfile = (profile, lookups) => {
  if (!profile) return profile;

  const prodiData = findProfileProdi(profile, lookups.prodiList || []);

  return {
    ...profile,
    prodiData,
    prodi_display: formatProdi(prodiData),
  };
};

export const hydrateProfiles = (profiles, lookups) =>
  (profiles || []).map((profile) => hydrateProfile(profile, lookups));
